import React from "react";

import { Button } from "~/ui";

import styles from "./NeedsActionBanner.module.css";

interface NeedsActionBannerProps {
	amount: number;
	onClick(): void;
}

export default function NeedsActionBanner({ amount, onClick }: NeedsActionBannerProps) {
	return (
		<Button size="wide" className={styles.banner} onClick={onClick}>
			{amount} request{amount > 1 ? "s" : ""} need{amount === 1 ? "s" : ""} action
		</Button>
	);
}
